<template>
  <div
    class="ui-default-view"
    :class="{ 'collapsed-side-nav': preferencesStore.collapseSideNav }"
  >
    <SideNav
      :collapsed="preferencesStore.collapseSideNav"
      @onExpand="preferencesStore.collapseSideNav = false"
      @onCollapse="preferencesStore.collapseSideNav = true"
    />
    <router-view />
  </div>
</template>

<script setup>
import SideNav from '@frontend/ui/components/global/SideNav.vue';
import { usePreferencesStore } from '@stores/preferencesStore';

const preferencesStore = usePreferencesStore();
</script>

<style scoped>
.ui-default-view {
  display: grid;
  min-height: 100vh;
  grid-template-columns: var(--stk-sidenav-width) 1fr;
  align-items: stretch;
  transition-duration: var(--stk-transition-duration);
  transition-property: grid-template-columns;

  &.collapsed-side-nav {
    grid-template-columns: var(--stk-sidenav-collapsed-width) 1fr;
  }
}
</style>
